/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import WsShareButtonsDisplay from './WsShareButtonsDisplay';
import AppText from '../../../../common/AppText';
import AppStack from '../../../../common/AppStack';
import { getWebstoreSubHeadingSize } from '../../../../../helpers/webstoreHelper';

const WsShareButtons = ({
  config,
  themeConfig,
  colorScheme,
  baseStoreUrl,
  baseResourceUrl,
  ecomStoreProduct
}) => {
  const shareImageUrl = '';
  const isResourceShare = !!baseResourceUrl && !!ecomStoreProduct;
  const sharePath = isResourceShare
    ? `${baseResourceUrl}/products/${ecomStoreProduct.urlHandle}`
    : baseStoreUrl;

  return (
    <AppStack
      style={{
        paddingTop: config.topPadding * 1 || 0,
        paddingBottom: config.bottomPadding * 1 || 0,
        gap: 8
      }}
    >
      {config.heading && (
        <AppText
          style={{
            fontWeight: 500,
            fontSize: getWebstoreSubHeadingSize(config.headingSize),
            wordBreak: 'break-word',
            overflowWrap: 'break-word'
          }}
        >
          {config.heading}
        </AppText>
      )}
      <WsShareButtonsDisplay
        baseStoreUrl={sharePath}
        buttonFlow={config.shareButtonFlow}
        colorScheme={colorScheme}
        iconSize={config.iconSize * 1}
        isResourceShare={isResourceShare}
        maxIconsShown={config.maxIconsShown * 1 || 4}
        menuColorScheme={colorScheme}
        shareImageUrl={shareImageUrl}
        showIcons={config.showIcons === 'true'}
        themeConfig={themeConfig}
      />
    </AppStack>
  );
};

WsShareButtons.propTypes = {
  baseResourceUrl: PropTypes.string,
  baseStoreUrl: PropTypes.string,
  colorScheme: PropTypes.object,
  config: PropTypes.object,
  ecomStoreProduct: PropTypes.object,
  themeConfig: PropTypes.object
};

export default WsShareButtons;
